import { render } from "./TestimonialBanner.vue?vue&type=template&id=bb6a87f8"
import script from "./TestimonialBanner.vue?vue&type=script&lang=js"
export * from "./TestimonialBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__